// This file is auto-generated by dibs-icons script
import { FC } from 'react';
import Article20 from './Article20';
import Article20Filled from './Article20Filled';
import Article20CircleFilled from './Article20CircleFilled';
import Article24 from './Article24';
import Article24Filled from './Article24Filled';
import Article24CircleFilled from './Article24CircleFilled';
import Article40 from './Article40';
import Article40Filled from './Article40Filled';
import Article48 from './Article48';
import Article48Filled from './Article48Filled';

type ArticleProps = {
    variation:
        | '20'
        | '20Filled'
        | '20CircleFilled'
        | '24'
        | '24Filled'
        | '24CircleFilled'
        | '40'
        | '40Filled'
        | '48'
        | '48Filled';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Article20,
    Article20Filled,
    Article20CircleFilled,
    Article24,
    Article24Filled,
    Article24CircleFilled,
    Article40,
    Article40Filled,
    Article48,
    Article48Filled,
};

const Article: FC<ArticleProps> = ({ variation, ...props }) => {
    const variationKey = `Article${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Article" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Article;
